
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 54.21 47.49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.09 26.86A18.44 18.44 0 0051 18.48a18.56 18.56 0 00-15.35-8.21H9.28l4.36-4.37 1.28-1.27a2.8 2.8 0 00.79-1.92A2.71 2.71 0 0013 0a2.82 2.82 0 00-1.92.8L7.62 4.26 2.08 9.8c-.4.39-.79.79-1.18 1.18l-.1.08A2.78 2.78 0 000 13a2.82 2.82 0 00.72 1.83l.08.1 3.46 3.46 5.55 5.55 1.27 1.27A2.83 2.83 0 0013 26a2.7 2.7 0 002.71-2.71 2.86 2.86 0 00-.79-1.92l-3.46-3.46-2.19-2.2h26.85c.46 0 .9.06 1.35.11a16.57 16.57 0 013.26.9 16.27 16.27 0 012.86 1.66 16.81 16.81 0 012.53 2.53 16.27 16.27 0 011.66 2.86 15.74 15.74 0 01.9 3.31 16.48 16.48 0 010 3.58 15.94 15.94 0 01-.91 3.34 15.67 15.67 0 01-1.66 2.86 15.53 15.53 0 01-2.53 2.53A15.67 15.67 0 0140.72 41a15.74 15.74 0 01-3.31.9 30.72 30.72 0 01-3.18.11H14.31a2.81 2.81 0 00-1.92.8 2.76 2.76 0 00-.8 1.92 2.68 2.68 0 00.8 1.91 2.81 2.81 0 001.92.8h17.45a33.08 33.08 0 008.6-.62 18.59 18.59 0 0012.7-11.55 19.15 19.15 0 001-4.43 15.91 15.91 0 00.03-3.98z","fill":"#010101"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/revert.svg